import React from 'react'
// libs
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { formValueSelector, InjectedFormProps, reduxForm } from 'redux-form'
// components
import { ReduxSwitch } from 'components/FormElements/ReduxForm'
// view components
import InputLabel from 'components/FormElements/components/InputLabel'
import SingleReviewForm from 'components/Modals/CreateScheduledReviewModal/components/Form/components/SingleReviewForm'
import RepeatingReviewForm from 'components/Modals/CreateScheduledReviewModal/components/Form/components/RepeatingReviewForm'

const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;

  > div {
    width: fit-content;
  }
`

const EntityDefaultsForm: React.FC<InjectedFormProps<any>> = ({ form, reset }) => {
  const isRepeating = useSelector((state) => formValueSelector(form)(state, 'repeating'))

  return (
    <div>
      <SwitchContainer>
        <InputLabel>Repeating review</InputLabel>
        <ReduxSwitch name={'repeating'} justifyContent={'flex-end'} onClick={reset} />
      </SwitchContainer>
      {isRepeating ? <RepeatingReviewForm form={form} hideReviewers /> : <SingleReviewForm form={form} hideReviewers />}
    </div>
  )
}

export default reduxForm<any>({ enableReinitialize: true, destroyOnUnmount: false })(EntityDefaultsForm)
